import { Component, OnInit } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { BookingSlotStateService } from '../../services/booking-slot-state.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { LoggerService } from '../../../../services/logger/logger.service';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { BookingStepService } from '../../services/booking-step.service';
import { OrderTypeEnum } from '../../../order/models/order-type.enum';
import { BookingSlot } from '../../models/booking-slot';
import { BookingOrderService } from '../../services/booking-order.service';
import { PaymentStateService } from '../../../payment/services/payment-state.service';
import { Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'app-booking-slots',
  templateUrl: './booking-slots.component.html',
  styleUrls: ['./booking-slots.component.css']
})
export class BookingSlotsComponent implements OnInit, OnDestroy {

  private _initializeBookingSlotStateService: Subscription;

  constructor(
    private bookingSlotStateService: BookingSlotStateService,
    private bookingStepService: BookingStepService,
    private logger: LoggerService,
    private bookingOrderService: BookingOrderService,
    private paymentStateService: PaymentStateService,
  ) { }

  ngOnInit(): void {
    this._initializeBookingSlotStateService = this.bookingSlotStateService.initialize()
      .subscribe(
        _ => {
          this.paymentStateService.reset();
          if (this.bookingStepService.step !== BookingStepEnum.SelectBookingPacks
            && this.bookingStepService.step !== BookingStepEnum.SelectNearestBookingSingleProducts) {
            this.bookingStepService.update(BookingStepEnum.SelectBookingPacks);
          }
          this.logger.info('BookingSlotsComponent: bookingSlotStateService initialized.');
        }
      );
  }

  onTimeSlotSelected(timeSlot: BookingSlot): void {
    const selectedBookingDate = this.bookingSlotStateService.getSelectedBookingDate(timeSlot);

    let orderType = BookingStepEnum.SelectBookingSingleProducts;
    if (this.bookingOrderService.isEventTypeOrder) {
      orderType = BookingStepEnum.SelectBookingEventProducts;
    }

    this.bookingStepService.update(
      orderType,
      null,
      null,
      selectedBookingDate,
      this.isEvent ? this.bookingSlotStateService.timeSlots.filter(x => x.fromTime === timeSlot.fromTime) : [timeSlot],
    );
  }


  private _unsubscribeInitializeBookingSlotStateService(): void {
    if (this._initializeBookingSlotStateService) {
      this._initializeBookingSlotStateService.unsubscribe();
      this._initializeBookingSlotStateService = null;
    }
  }

  get isEvent(): boolean {
    return this.bookingSlotStateService.isBirthday || this.bookingSlotStateService.isGroup;
  }

  ngOnDestroy(): void {
    this._unsubscribeInitializeBookingSlotStateService();
  }
}
